import { fetchResource } from "../../resources/actions";

const NAME = "tasks";
const PATH = "tasks";

export const fetchTask = (taskId) =>
  fetchResource(NAME, `${PATH}/${taskId}/status`, null);

export const awaitTask = (taskId, delay, retries) => (dispatch) =>
  new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      let last;

      if (retries === 0) {
        clearInterval(interval);

        return reject(last);
      }

      dispatch(fetchTask(taskId)).then((data) => {
        if (["SUCCESS", "FAILED", "FAILURE"].includes(data.value.status)) {
          clearInterval(interval);

          return data.value.status === "SUCCESS"
            ? resolve(data.value)
            : reject(data.value);
        }

        last = data;
      });

      retries--;
    }, delay);
  });

export default {
  fetchResource: fetchTask,
};
